import { createFileRoute } from '@tanstack/react-router'

import { PlatformBillingExemptionPage } from '../../../../../components/pages/backoffice/platform/platform-billing-exemption-page/platform-billing-exemption-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/billing-exemption')({
  component: () => (
    <PermissionChecker
      requiredPermissions={[
        'billingExemption.create',
        'billingExemption.update',
        'billingExemption.delete',
        'billingExemption.read',
      ]}
    >
      <PlatformBillingExemptionPage />
    </PermissionChecker>
  ),
})
